import React from 'react';
import { Form, Input } from '@agconnections/grow-ui';
import GrowUIFormField from 'components/Forms/GrowUIFormField';

const AddressLineTwoField = () => {
  return (
    <Form.Field label="Address Line 2">
      <GrowUIFormField control={Input} id="line2" name="address.line2" />
    </Form.Field>
  );
};

export default AddressLineTwoField;
